import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import { gsap } from "gsap";
import ApiURl from "../../controllers/Api";

function AdminHeroSlides() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingSlide, setEditingSlide] = useState(null);

  const [latestProducts, setLatestProducts] = useState([]);
  const [fetchingProducts, setFetchingProducts] = useState(false);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [copyingImage, setCopyingImage] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [buttonText, setButtonText] = useState("EXPLORE");
  const [buttonLink, setButtonLink] = useState("#home-products");
  const [sortOrder, setSortOrder] = useState("1");
  const [isActive, setIsActive] = useState(true);

  const [imageFile, setImageFile] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [copiedImagePath, setCopiedImagePath] = useState("");
  const fileInputRef = useRef(null);

  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, type: "info", msg: "" });

  const pageRef = useRef(null);
  const listRef = useRef(null);
  const dropdownRef = useRef(null);

  const transparentPixel =
    "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=";

  const showToast = (type, msg) => {
    setToast({ show: true, type, msg });
    gsap.fromTo(
      ".toast-anim",
      { y: 12, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.25, ease: "power2.out" }
    );
    clearTimeout(showToast._t);
    showToast._t = setTimeout(
      () => setToast((t) => ({ ...t, show: false })),
      2600
    );
  };

  const normalizeImagePath = (val) => {
    if (!val) return "";
    if (Array.isArray(val)) return val[0] || "";
    if (typeof val === "string") {
      const s = val.trim();
      if (s.startsWith("[") && s.endsWith("]")) {
        try {
          const arr = JSON.parse(s);
          if (Array.isArray(arr) && arr.length) return arr[0] || "";
        } catch {}
      }
      return s;
    }
    return String(val);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProductDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isSortOrderAvailable = (order, excludeId = null) => {
    const numOrder = parseInt(order, 10);
    if (isNaN(numOrder) || numOrder < 1) return false;

    return !slides.some(
      (slide) =>
        slide.sort_order === numOrder &&
        (excludeId === null || slide.id !== excludeId)
    );
  };

  const getNextAvailableSortOrder = () => {
    const takenOrders = slides.map((s) => s.sort_order);
    for (let i = 1; i <= 10; i++) {
      if (!takenOrders.includes(i)) return i.toString();
    }
    return (slides.length + 1).toString();
  };

  const handleSortOrderChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      setSortOrder("");
      return;
    }
    const numericValue = value.replace(/[^0-9]/g, "");
    if (numericValue !== "") {
      let numValue = parseInt(numericValue, 10);
      if (numValue > 999) numValue = 999;
      setSortOrder(numValue.toString());
    }
  };

  const handleSortOrderBlur = () => {
    if (sortOrder === "") {
      setSortOrder(getNextAvailableSortOrder());
      return;
    }
    const numOrder = parseInt(sortOrder, 10);
    if (numOrder < 1) setSortOrder("1");
  };

  const extractProductImage = (product) => {
    if (!product) return null;

    const possibleFields = [
      "img_path",
      "image",
      "product_image",
      "image_path",
      "images",
      "image_url",
    ];

    for (const field of possibleFields) {
      const value = product[field];
      if (value) {
        if (Array.isArray(value) && value.length > 0) {
          const firstItem = value[0];
          if (typeof firstItem === "string") return firstItem;
          if (firstItem?.url) return firstItem.url;
          if (firstItem?.image_path) return firstItem.image_path;
        }

        if (typeof value === "string") return value;
        if (value?.url) return value.url;
      }
    }
    return null;
  };

  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (
      imagePath.startsWith("http://") ||
      imagePath.startsWith("https://")
    )
      return imagePath;

    const clean = imagePath.replace(/^\/+/, "").replace(/^ajax\//, "");

    if (!clean.includes("/")) return `${ApiURl}/images/${clean}`;

    return `${ApiURl}/${clean}`;
  };
const resolveSlideImageUrl = (slide) => {
  const raw = (slide?.image_url || slide?.image_path || "").toString().trim();
  if (!raw) return "";

  // already full url from backend
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;

  // remove leading slashes and accidental "ajax/"
  const clean = raw.replace(/^\/+/, "").replace(/^ajax\//, "");

  // if just filename -> hero images are in ajax/images
  if (!clean.includes("/")) return `${ApiURl}/images/${clean}`;

  // if it is "images/xxx.jpg" or "uploads/xxx.jpg"
  return `${ApiURl}/${clean}`;
};
  const copyProductImage = async (productId, imagePath) => {
    setCopyingImage(true);
    try {
      const fixedImagePath = normalizeImagePath(imagePath);

      const formData = new FormData();
      formData.append("product_id", productId);
      formData.append("image_path", fixedImagePath);

      const response = await $.ajax({
        url: `${ApiURl}/copyProductImage.php`,
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        dataType: "json",
      });

      if (response?.success || response?.status === true) {
        setCopiedImagePath(response.file_path);
        setImagePreviewUrl(response.file_url);
        showToast("success", "Product image loaded successfully");
        return true;
      } else {
        showToast("error", response?.message || "Failed to copy image");
        return false;
      }
    } catch (error) {
      showToast("error", "Failed to copy product image");
      return false;
    } finally {
      setCopyingImage(false);
    }
  };

  const fetchLatestProducts = async () => {
    setFetchingProducts(true);
    try {
      const response = await $.ajax({
        url: `${ApiURl}/getallproducts.php`,
        method: "GET",
        dataType: "json",
        timeout: 10000,
      });

      let productList = [];
      if (response?.status === "success" && Array.isArray(response?.products)) {
        productList = response.products;
      } else if (Array.isArray(response)) {
        productList = response;
      } else if (response?.data) {
        productList = response.data;
      }

      const sorted = productList
        .filter((product) => product && product.product_id)
        .sort((a, b) => {
          const dateA = new Date(a.created_at || a.createdAt || 0);
          const dateB = new Date(b.created_at || b.createdAt || 0);
          return dateB - dateA;
        })
        .slice(0, 5)
        .map((product) => {
          const rawPath = extractProductImage(product);
          const imagePath = normalizeImagePath(rawPath);

          return {
            id: product.product_id,
            name: product.product_name || product.name || "Unnamed Product",
            description: product.description || product.short_description || "",
            image_path: imagePath,
            image_url: imagePath ? getFullImageUrl(imagePath) : null,
            button_text: "EXPLORE",
            button_link: `/ProductOverview/${product.product_id}`,
          };
        });

      setLatestProducts(sorted);
      setShowProductDropdown(true);

      if (sorted.length === 0) showToast("info", "No products found in database");
      else showToast("success", `Found ${sorted.length} latest products`);
    } catch (error) {
      showToast("error", "Failed to fetch products");
    } finally {
      setFetchingProducts(false);
    }
  };

  const applyProductData = async (product) => {
    setTitle(product.name);
    setDescription(product.description || "Premium quality product");
    setButtonText(product.button_text);
    setButtonLink(product.button_link);

    if (product.image_path) {
      const success = await copyProductImage(product.id, product.image_path);
      if (!success) showToast("warning", "Please upload image manually");
    } else {
      showToast("warning", "No image found for this product");
    }

    setShowProductDropdown(false);
  };

  const fetchSlides = async () => {
    setLoading(true);
    const url = `${ApiURl}/getSlides.php?_ts=${Date.now()}`;

    try {
      const raw = await $.ajax({
        url,
        method: "GET",
        dataType: "text",
        cache: false,
        timeout: 20000,
      });

      let json;
      try {
        json = JSON.parse(raw);
      } catch {
        showToast("error", "API returned invalid JSON.");
        return;
      }

      if (json?.success) {
        setSlides(json.data || []);
      } else {
        showToast("error", json?.message || "Failed to load slides");
      }
    } catch (xhr) {
      showToast("error", `Failed to load slides (HTTP ${xhr?.status || "?"})`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSlides();
  }, []);

  useEffect(() => {
    if (!editingSlide) setSortOrder(getNextAvailableSortOrder());
  }, [slides, editingSlide]);

  const handleImageUpload = (e) => {
    const file = (e.target.files && e.target.files[0]) || null;
    if (!file) return;

    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      showToast("error", "Please select a valid image file.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showToast("error", "File too large. Maximum 5MB.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    if (imagePreviewUrl) URL.revokeObjectURL(imagePreviewUrl);

    const url = URL.createObjectURL(file);
    setImageFile(file);
    setImagePreviewUrl(url);
    setCopiedImagePath("");
  };

  const removeImage = () => {
    if (imagePreviewUrl) URL.revokeObjectURL(imagePreviewUrl);
    setImageFile(null);
    setImagePreviewUrl("");
    setCopiedImagePath("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setButtonText("EXPLORE");
    setButtonLink("#home-products");
    setSortOrder(getNextAvailableSortOrder());
    setIsActive(true);
    removeImage();
    setEditingSlide(null);
  };

  const handleEdit = (slide) => {
    setEditingSlide(slide);
    setTitle(slide.title || "");
    setDescription(slide.description || "");
    setButtonText(slide.button_text || "EXPLORE");
    setButtonLink(slide.button_link || "#home-products");
    setSortOrder(slide.sort_order?.toString() || "1");
    setIsActive(slide.is_active == 1);

    setImagePreviewUrl(resolveSlideImageUrl(slide));
    setImageFile(null);
    setCopiedImagePath(slide.image_path || "");

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this slide?")) return;

    try {
      const response = await $.ajax({
        url: `${ApiURl}/deleteHeroSlide.php?id=${id}`,
        type: "DELETE",
        dataType: "json",
      });

      if (response?.success) {
        showToast("success", "Slide deleted successfully");
        await fetchSlides();
        setSortOrder(getNextAvailableSortOrder());
      } else {
        showToast("error", response?.message || "Failed to delete slide");
      }
    } catch {
      showToast("error", "Server error while deleting slide");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (sortOrder === "") {
      showToast("error", "Please enter a sort order.");
      return;
    }

    const numSortOrder = parseInt(sortOrder, 10);

    if (!title.trim()) {
      showToast("error", "Please enter a title.");
      return;
    }

    if (!description.trim()) {
      showToast("error", "Please enter a description.");
      return;
    }

    if (!imageFile && !copiedImagePath && !editingSlide) {
      showToast("error", "Please upload an image or select a product with image.");
      return;
    }

    if (!isSortOrderAvailable(numSortOrder, editingSlide?.id)) {
      showToast(
        "error",
        `Sort order ${numSortOrder} is already taken. Please choose another number.`
      );
      return;
    }

    setSubmitting(true);

    const formData = new FormData();

    if (copiedImagePath && !imageFile) {
      formData.append("copied_image_path", copiedImagePath);
    } else if (imageFile) {
      formData.append("image", imageFile);
    }

    formData.append("title", title.trim());
    formData.append("description", description.trim());
    formData.append("button_text", buttonText.trim());
    formData.append("button_link", buttonLink.trim());
    formData.append("sort_order", numSortOrder.toString());
    formData.append("is_active", isActive ? "1" : "0");

    const url = editingSlide
      ? `${ApiURl}/updateHeroSlide.php?id=${editingSlide.id}`
      : `${ApiURl}/addHeroSlide.php`;

    try {
      const response = await $.ajax({
        url,
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        dataType: "json",
      });

     if (response?.success || response?.status === true) {
  showToast(
    "success",
    editingSlide ? "Slide updated successfully" : "Slide added successfully"
  );
  resetForm();
  await fetchSlides();
} else {
  showToast("error", response?.message || "Failed to save slide");
}
    } catch {
      showToast("error", "Server error while saving slide");
    } finally {
      setSubmitting(false);
    }
  };

  const isSortOrderValid = () => {
    if (sortOrder === "") return false;
    const numOrder = parseInt(sortOrder, 10);
    if (isNaN(numOrder) || numOrder < 1) return false;
    return isSortOrderAvailable(numOrder, editingSlide?.id);
  };

  return (
    <div ref={pageRef} className="w-full font-['Poppins',sans-serif] bg-gray-50 min-h-screen">
      {toast.show && (
        <div className="toast-anim fixed bottom-5 right-5 z-[9999]">
          <div
            className={[
              "rounded-xl px-4 py-3 shadow-lg border text-sm",
              toast.type === "success"
                ? "bg-emerald-50 border-emerald-200 text-emerald-900"
                : toast.type === "error"
                ? "bg-rose-50 border-rose-200 text-rose-900"
                : "bg-slate-50 border-slate-200 text-slate-900",
            ].join(" ")}
          >
            {toast.msg}
          </div>
        </div>
      )}

      <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto">
        <div className="mb-6 flex items-start justify-between gap-3">
          <div>
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900">
              Hero Slides Management
            </h1>
            <p className="text-sm text-slate-600 mt-1">
              Manage the slides that appear in the Ecommerce Products hero section.
            </p>
            <div className="mt-2 inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-50 text-blue-700 border border-blue-200">
              {slides.length} Slides
            </div>
          </div>

          <div className="flex gap-2">
            <button
              type="button"
              className="px-3 py-2 text-xs font-semibold bg-white border border-slate-200 rounded-xl hover:bg-slate-50"
              onClick={() => fetchSlides()}
            >
              Refresh
            </button>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm mb-8">
          <div className="px-6 py-5 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-slate-900">
                {editingSlide ? "Edit Slide" : "Add New Slide"}
              </h2>

              <div className="relative" ref={dropdownRef}>
                <button
                  type="button"
                  onClick={fetchLatestProducts}
                  disabled={fetchingProducts || copyingImage}
                  className={[
                    "inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition",
                    fetchingProducts || copyingImage
                      ? "bg-slate-400 text-white cursor-not-allowed"
                      : "bg-blue-600 text-white hover:bg-blue-700 active:scale-[0.99]",
                  ].join(" ")}
                >
                  {fetchingProducts || copyingImage ? (
                    <>
                      <svg
                        className="animate-spin h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      {copyingImage ? "Copying Image..." : "Loading..."}
                    </>
                  ) : (
                    <>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M20 7v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7" />
                        <path d="M12 3v12m0 0-3-3m3 3 3-3" />
                      </svg>
                      Get Latest Products
                    </>
                  )}
                </button>

                {showProductDropdown && latestProducts.length > 0 && (
                  <div className="absolute right-0 mt-2 w-96 bg-white rounded-xl shadow-lg border border-slate-200 z-50 max-h-96 overflow-y-auto">
                    <div className="p-3 border-b border-slate-200 bg-slate-50 rounded-t-xl">
                      <h3 className="text-sm font-medium text-slate-900">
                        Select a product to auto-fill
                      </h3>
                    </div>
                    <div className="p-2">
                      {latestProducts.map((product) => (
                        <button
                          key={product.id}
                          type="button"
                          onClick={() => applyProductData(product)}
                          disabled={copyingImage}
                          className="w-full text-left p-3 hover:bg-slate-50 rounded-lg transition flex items-start gap-3 border-b border-slate-100 last:border-0 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <div className="flex-1">
                            <div className="font-medium text-sm text-slate-900">
                              {product.name}
                            </div>
                            <div className="text-xs text-slate-500 line-clamp-2 mt-1">
                              {product.description || "No description"}
                            </div>

                            {product.image_url ? (
                              <div className="mt-2 flex items-center gap-2">
                                <img
                                  src={product.image_url}
                                  alt={product.name}
                                  className="w-12 h-12 object-cover rounded border border-slate-200"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = transparentPixel;
                                  }}
                                />
                                <div className="text-xs text-green-600">
                                  ✓ Image available
                                </div>
                              </div>
                            ) : (
                              <div className="text-xs text-amber-600 mt-2 flex items-center gap-1">
                                <span>⚠️</span>
                                <span>No image - upload manually</span>
                              </div>
                            )}

                            <div className="text-xs text-blue-600 mt-2">
                              Link: {product.button_link}
                            </div>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="block mb-1 text-sm font-medium text-slate-900">
                    Title <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#b29063]/30 focus:border-[#b29063]"
                    placeholder="e.g., Tea Cups"
                    maxLength="100"
                    required
                  />
                </div>

                <div>
                  <label className="block mb-1 text-sm font-medium text-slate-900">
                    Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#b29063]/30 focus:border-[#b29063]"
                    placeholder="e.g., Comfortable tea cups for daily sips—simple and inviting."
                    maxLength="200"
                    required
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-1 text-sm font-medium text-slate-900">
                      Button Text
                    </label>
                    <input
                      type="text"
                      value={buttonText}
                      onChange={(e) => setButtonText(e.target.value)}
                      className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#b29063]/30 focus:border-[#b29063]"
                      placeholder="EXPLORE"
                    />
                  </div>
                  <div>
                    <label className="block mb-1 text-sm font-medium text-slate-900">
                      Button Link
                    </label>
                    <input
                      type="text"
                      value={buttonLink}
                      onChange={(e) => setButtonLink(e.target.value)}
                      className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#b29063]/30 focus:border-[#b29063]"
                      placeholder="#home-products"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-1 text-sm font-medium text-slate-900">
                      Sort Order <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      inputMode="numeric"
                      value={sortOrder}
                      onChange={handleSortOrderChange}
                      onBlur={handleSortOrderBlur}
                      className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#b29063]/30 focus:border-[#b29063]"
                      placeholder="1"
                    />
                    <p className="text-xs text-slate-500 mt-1">
                      Lower numbers appear first
                    </p>
                    {sortOrder !== "" &&
                      !isSortOrderAvailable(parseInt(sortOrder, 10), editingSlide?.id) && (
                        <p className="text-xs text-red-500 mt-1">
                          ⚠️ Order {sortOrder} is already taken
                        </p>
                      )}
                  </div>
                  <div>
                    <label className="block mb-1 text-sm font-medium text-slate-900">
                      Status
                    </label>
                    <div className="flex items-center h-[42px]">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={isActive}
                          onChange={(e) => setIsActive(e.target.checked)}
                          className="w-4 h-4 rounded border-slate-300 text-[#b29063] focus:ring-[#b29063]"
                        />
                        <span className="text-sm text-slate-700">Active</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-slate-900">
                  Slide Image <span className="text-red-500">*</span>
                </label>

                <label
                  htmlFor="slide-image"
                  className="flex flex-col items-center justify-center w-full rounded-2xl cursor-pointer border-2 border-dashed border-slate-300 bg-slate-50 hover:bg-slate-100 transition p-8 text-center mb-3"
                >
                  <div className="flex flex-col items-center justify-center gap-2">
                    <div className="h-12 w-12 rounded-2xl bg-white border border-slate-200 flex items-center justify-center shadow-sm">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="text-slate-600"
                      >
                        <path
                          d="M12 16V8M8 12h8"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M20 16.5V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1.5"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M7 10.5 12 6l5 4.5"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <p className="text-sm text-slate-700">
                      <span className="font-semibold">Click to upload</span> or drag and
                      drop
                    </p>
                    <p className="text-xs text-slate-500">
                      Images (JPG, PNG, GIF, WebP)
                    </p>
                    <p className="text-xs text-slate-400">Max: 5MB</p>
                  </div>

                  <input
                    ref={fileInputRef}
                    id="slide-image"
                    type="file"
                    className="hidden"
                    onChange={handleImageUpload}
                    accept="image/*"
                  />
                </label>

                {imagePreviewUrl && (
                  <div className="mt-3">
                    <div className="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
                      <div className="relative">
                        <img
                          src={imagePreviewUrl}
                          alt="Slide Preview"
                          className="w-full h-48 object-cover bg-white"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = transparentPixel;
                          }}
                        />

                        <button
                          type="button"
                          onClick={removeImage}
                          className="absolute top-2 right-2 rounded-full px-3 py-1 text-xs bg-white/90 border border-slate-200 hover:bg-slate-50 transition shadow-sm"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {copiedImagePath && !imageFile && (
                  <div className="mt-2 text-xs text-green-600 text-center">
                    ✓ Image ready from product: {copiedImagePath.split("/").pop()}
                  </div>
                )}

                <div className="flex gap-3 mt-4">
                  <button
                    type="submit"
                    disabled={submitting || !isSortOrderValid()}
                    className={[
                      "flex-1 inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-semibold text-white transition",
                      submitting || !isSortOrderValid()
                        ? "bg-slate-400 cursor-not-allowed"
                        : "bg-[#b29063] hover:bg-[#a08053] active:scale-[0.99]",
                    ].join(" ")}
                  >
                    {submitting
                      ? "Saving..."
                      : editingSlide
                      ? "Update Slide"
                      : "Add Slide"}
                  </button>

                  {editingSlide && (
                    <button
                      type="button"
                      onClick={resetForm}
                      className="px-5 py-3 text-sm font-semibold text-slate-700 bg-white border border-slate-300 rounded-xl hover:bg-slate-50 transition"
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm">
          <div className="px-6 py-5 border-b border-slate-200">
            <h2 className="text-lg font-semibold text-slate-900">Current Slides</h2>
            <p className="text-sm text-slate-600 mt-1">Manage your hero section slides</p>
          </div>

          <div ref={listRef} className="p-6">
            {loading ? (
              <div className="text-center py-8 text-slate-600">Loading slides...</div>
            ) : slides.length === 0 ? (
              <div className="text-center py-8 text-slate-600">No slides added yet.</div>
            ) : (
              <div className="space-y-4">
                {slides
                  .slice()
                  .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
                  .map((slide) => (
                    <div
                      key={slide.id}
                      className="flex flex-col sm:flex-row items-start sm:items-center gap-4 p-4 bg-slate-50 rounded-xl border border-slate-200 hover:shadow-sm transition"
                    >
                      <div className="w-32 h-24 rounded-lg overflow-hidden bg-white border border-slate-200 flex-shrink-0">
                        <img
                          src={resolveSlideImageUrl(slide)}
                          alt={slide.title}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = transparentPixel;
                          }}
                        />
                      </div>

                      <div className="flex-1">
                        <div className="flex items-center gap-2 flex-wrap">
                          <h3 className="font-medium text-slate-900">{slide.title}</h3>
                          <span
                            className={[
                              "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
                              slide.is_active == 1
                                ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                                : "bg-slate-100 text-slate-600 border border-slate-200",
                            ].join(" ")}
                          >
                            {slide.is_active == 1 ? "Active" : "Inactive"}
                          </span>
                          <span className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200">
                            #{slide.sort_order || 0}
                          </span>
                        </div>
                        <p className="text-sm text-slate-600 mt-1 line-clamp-2">
                          {slide.description}
                        </p>
                        <div className="flex flex-wrap gap-3 mt-2 text-xs text-slate-500">
                          <span>🔘 {slide.button_text || "EXPLORE"}</span>
                          <span>🔗 {slide.button_link || "#home-products"}</span>
                        </div>
                      </div>

                      <div className="flex gap-2 ml-auto">
                        <button
                          onClick={() => handleEdit(slide)}
                          className="px-3 py-1.5 text-xs font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(slide.id)}
                          className="px-3 py-1.5 text-xs font-medium text-red-600 bg-white border border-slate-200 rounded-lg hover:bg-red-50 transition"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminHeroSlides;